

















































































import Vue, {VueConstructor} from 'vue'
import Message from '@/models/Message/Message'
import messageCom from './msg.vue'
import luxon from 'luxon'
import {Dictionary} from 'vuex'
import _ from 'lodash'
// @ts-ignore
import EmojiPicker from '@/components/EmojiPicker/EmojiPicker'
export default (Vue as VueConstructor<Vue & {
  $refs: {
    container: HTMLElement,
    scrollbar: {
      setScrollTop: (val: number) => void,
      $refs: {
        content: HTMLElement
      }
    },
    group: HTMLElement[]
  }
}>).extend({
  components: {
    messageCom,
    EmojiPicker
  },
  props: {
    list: Array as () => Message[],
    stubText: String,
    disabled: Boolean,
    isLoading: Boolean,
    defaultHeight: {
      type: Number,
      default: 600
    }
  },
  data () {
    return {
      messageText: '',
      isInputFocused: false,
      isInputDisabled: false,
      visibleGropus: {} as Dictionary<Message[]>,
      containerHeight: 0,
      currentDate: '',
      currentDateVis: false,
      height: 0
    }
  },
  methods: {
    // @ts-ignore
    onPickEmoji (emoji) {
      this.messageText += `${emoji}`;
    },
    onInputFocus () {
      this.isInputFocused = true
    },
    onInputBlur () {
      this.isInputFocused = false
    },
    onScrollUp (event: UIEvent) {
      this.$emit('onScrollUp')
    },
    onScroll (event: UIEvent) {
      this.setVisibleGroups()
      const visG = this.getVisibleGroups()
      this.setCurrentDay(visG)
      this.currentDateVis = true;
    },
    setInputDisabled (val: boolean) {
      this.isInputDisabled = !!val
    },
    getScrollTop (): number {
      return this.$refs.scrollbar.$refs.content.scrollTop
    },
    setCurrentDay (visG: Dictionary<Message[]>): void {
      if (Object.keys(visG).length) {
        const first = Object.keys(visG)[0]
        this.currentDate = visG[first][0].getSendDate('dd.LL.yyyy')
      }
    },
    getVisibleGroups (): Dictionary<Message[]> {
      return this.visibleGropus
    },
    setVisibleGroups (): void {
      const upBorder = this.getScrollTop()
      const downBorder = this.getScrollTop() + this.$refs.scrollbar.$refs.content.clientHeight
      const groups = this.$refs.group
      const visibleKeys: string[] = []
      const visibleGroups: Dictionary<Message[]> = {}
      groups.forEach(group => {
        const gStart = group.offsetTop
        const gEnd = gStart + group.offsetHeight

        if (gStart < downBorder && gEnd > upBorder) {
          const gKey = group.getAttribute('data-g-key')
          if (gKey) {
            visibleKeys.push(gKey)
          }
        }
      });
      visibleKeys.sort((a, b) => a > b ? 1 : -1);

      for (const key of visibleKeys) {
        const g = this.groups[key]
        if (g) {
          visibleGroups[key] = g
        }
      }
      this.visibleGropus = visibleGroups
    },
    slideScrollToBottom () {
      const pos = this.$refs.scrollbar.$refs.content.scrollHeight - this.$refs.scrollbar.$refs.content.clientHeight
      this.setContentScrollTop(pos);
    },
    freezeScroll () {
      let diff = this.$refs.container.clientHeight - this.containerHeight
      this.setContentScrollTop(diff)
      this.setCurrentContainerHeight()
    },
    setContentScrollTop (val: number) {
      this.$refs.scrollbar.setScrollTop(val)
    },
    setCurrentContainerHeight () {
      if (this.$refs.container) {
        this.containerHeight = this.$refs.container.clientHeight;
      }
    },
    onSendClick () {
      const isEmpty = /^\s*$/.test(this.messageText)
      if (!isEmpty && !this.isInputDisabled) {
        this.$emit('input', this.messageText)
      }
    },
    onEnterKeyup (event: any) {
      if (event.keyCode === 13 && event.ctrlKey || event.metaKey) {
        this.onSendClick()
      }
    },
    clearMessageText (): void {
      this.messageText = ''
    },
    hideCurrentDate: _.debounce(function (scrollTop: number) {
      // @ts-ignore
      this.currentDateVis = false;
    }, 1000),
    setHeight (val: number) {
      this.height = val
    },
    onDragged (e: any) {
      if (e.deltaX === undefined) {
        e.deltaX = 0
      }
      if (e.deltaY === undefined) {
        e.deltaY = 0
      }
      this.setHeight(this.height + e.deltaY)
    }
  },
  computed: {
    map (): Dictionary<Message> {
      let map: Dictionary<Message> = {}
      for (const message of this.list) {
        const id = message.getId()
        if (!map[id]) {
          map[id] = message
        }
      }
      return map;
    },
    groups (): Dictionary<Message[]> {
      let map: Dictionary<Message[]> = {}
      for (const message in this.map) {
        let date = this.map[message].getSendDate('yyyyLLdd')
        if (!map[date]) {
          map[date] = []
        }
        map[date].push(this.map[message])
      }
      return map
    },
    sortedGroupsList (): Message[][] {
      let groupKeys: number[] = []
      for (const key in this.groups) {
        groupKeys.push(Number(key))
      }
      groupKeys.sort((a, b) => a > b ? 1 : -1);

      let sordetList = []
      for (const key of groupKeys) {
        if (this.groups[key]) {
          sordetList.push(this.groups[key])
        }
      }
      return sordetList;
    }
  },
  mounted () {
    this.setHeight(this.defaultHeight)
    setTimeout(() => {
      this.setCurrentContainerHeight()
    }, 2000);
    window.addEventListener('keyup', this.onEnterKeyup);
  },
  beforeDestroy () {
    window.removeEventListener('keyup', this.onEnterKeyup);
  }
})
